import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import "../../../../../../../scss/pages/_message-board.scss";
import { customerConstants } from "../../../../../../../constants";
import SelectField from "../../../../../../../shared/components/Fields/SelectField";
import SectionHeader from "../../../../../../../shared/components/Events/SectionHeader";
import MessageBoardView from "../../../../../../../shared/components/MessageBoard/MessageBoardView";
import MessageBoardModal from "../../../../../../../shared/components/MessageBoard/Modal/MessageBoardModal";
import {
  messageBoardActions,
  customerDashboardActions,
} from "../../../../../../../redux/actions";

const MessageBoard = (props) => {
  const smallScreenWidth = 768;
  const [isChatStarted, setIsChatStarted] = useState(false);
  const [currentActiveId, setCurrentActiveId] = useState(0);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);

  const eventId = useParams().eventId;
  const groupEventId = useParams().groupEventId;

  const [eventOptions, setEventOptions] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleSubmit = (sbId, imageUrl, name) => {
    const activeEventId = selectedEvent?.id ?? eventId;

    if (window.innerWidth < smallScreenWidth) {
      setIsMessageModalOpen(true);
      setIsChatStarted(false);
    } else {
      setIsChatStarted(true);
      setIsMessageModalOpen(false);
    }
    setCurrentActiveId(sbId);
    props.bulkUpdateMessageStatus(
      activeEventId,
      sbId,
      props.authentication.userId,
      props.authentication.userType
    );
    props.getMessages(activeEventId, sbId);
    props.setFormState({
      ...props.formState,
      userId: props.userId,
      senderId: props.userId,
      receiverId: sbId,
      profileImageUrl: imageUrl,
      sbUserId: sbId,
      name: name,
      email: props.data.email,
      eventId: activeEventId,
      sender: customerConstants.HOST,
    });
  };

  useEffect(() => {
    if (!props.allEvents?.length) return;

    if (props.allEvents.length > 1) {
      const options = props.allEvents.map(({ id, eventName }) => ({
        id: id,
        name: eventName,
        label: `${eventName} (ID: ${id})`,
        value: id,
      }));

      setEventOptions(options);

      const selected = options.find((opt) => opt.id == eventId);
      setSelectedEvent(selected);
    } else {
      setSelectedEvent(props?.allEvents[0]);
    }
    // eslint-disable-next-line
  }, [props.allEvents]);

  const handleSelect = (e) => {
    setSelectedEvent(e);
    setIsChatStarted(false);
  };

  useEffect(() => {
    props.getAllEventsByGroupId(groupEventId);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedEvent) {
      props.getshutterbzByEventId(selectedEvent?.id);
    }
    // eslint-disable-next-line
  }, [selectedEvent]);

  useEffect(() => {
    if (props?.data?.sbInfo?.length > 0) {
      const firstShutterB = props?.data?.sbInfo[0];
      if (window.innerWidth >= smallScreenWidth) {
        handleSubmit(
          firstShutterB?.id,
          firstShutterB?.profileImageUrl,
          firstShutterB?.firstName + " " + firstShutterB?.lastName
        );
      }
    }
  }, [props?.data?.sbInfo]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, []);

  const handleResize = () => {
    if (window.innerWidth && window.innerWidth >= 768) {
      setIsChatStarted(false);
      setIsMessageModalOpen(false);
      setCurrentActiveId(0);
    } else {
      setIsChatStarted(false);
      setCurrentActiveId(0);
    }
  };

  const handleCloseModal = () => {
    setIsMessageModalOpen(false);
    setCurrentActiveId(0);
  };

  return (
    <React.Fragment>
      <div className="container access-gallery px-0 ">
        {props?.allEvents?.length > 0 && (
          <SectionHeader
            eventId={eventId}
            groupId={groupEventId}
            itemCount={props.allEvents.length || 0}
            isGroup={props.allEvents.length > 1}
            title={
              props.allEvents.length > 1
                ? props.allEvents[0]?.eventGroupName
                : props.allEvents[0]?.eventName
            }
            className="px-4"
          />
        )}
        <div className="px-4 pt-2 pb-3">
          {props.allEvents?.length > 1 && (
            <div className="col-md-6 col-12 p-0">
              <SelectField
                options={eventOptions}
                id="select-event"
                label="select a sub event:"
                placeholder="select a sub event"
                value={selectedEvent}
                setValue={handleSelect}
              />
            </div>
          )}
          {props?.allEvents?.length > 0 && (
            <p className="py-3 m-0 text fw-600 text-dark">
              chat with your shutterb:
            </p>
          )}
          <div className="row w-100">
            {props.data.sbInfo?.length > 0 ? (
              <React.Fragment>
                <div class="col-md-6 col-lg-4 col-xl-3 chat pl-0">
                  <div class="card msg-card mb-sm-3 mb-md-0 contacts_card">
                    <div class="card-header msg-card-header d-flex align-items-center">
                      <p className="p-0 m-0 font-12 font-weight-bold text-light">
                        shutterb(z)
                      </p>
                    </div>
                    <div class="card-body contacts_body">
                      <ui class="contacts">
                        {props.data.sbInfo?.map((item) => {
                          return (
                            <li
                              className={
                                currentActiveId === item.id ? "active" : ""
                              }
                              onClick={() => {
                                handleSubmit(
                                  item.id,
                                  item.profileImageUrl,
                                  item.firstName + " " + item.lastName
                                );
                              }}
                            >
                              <div class="d-flex bd-highlight">
                                <div class="img_cont_msg">
                                  <img
                                    src={
                                      process.env
                                        .REACT_APP_S3_BASE_URL_PORTFOLIO +
                                      "/" +
                                      item.profileImageUrl
                                    }
                                    alt="User Profile"
                                    class="rounded-circle user_img"
                                  />
                                </div>
                                <div class="user-info-text ml-2">
                                  <span className="font-12 ellipsis-text">
                                    {item.firstName + " " + item.lastName}
                                  </span>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ui>
                    </div>
                    <div class="card-footer msg-card-footer top-border">
                      <p className="d-flex align-items-center font-12 text-black-60 justify-content-center mt-2 mb-2">
                        initialize chat with shutterb(z)
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-8 col-xl-9 p-0">
                  {isChatStarted ? (
                    <MessageBoardView
                      currentUser={customerConstants.HOST}
                      currentActiveId={currentActiveId}
                      userId={props.formState.userId}
                      sbUserId={props.formState.sbUserId}
                      eventId={props.formState.eventId}
                      profileImageUrl={props.formState.profileImageUrl}
                      currentUserId={props.userId}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </React.Fragment>
            ) : (
              <div className="col-md-12">
                <p className="pt-3 d-flex justify-content-center">
                  your event has not been accepted by shutterb(z) yet
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {isMessageModalOpen ? (
        <MessageBoardModal
          isMessageModalOpen={isMessageModalOpen}
          handleCloseModal={handleCloseModal}
          currentUser={customerConstants.HOST}
          currentUserId={props.userId}
          className="message-board-modal"
        />
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  data: state.messageBoard.data,
  userId: state.authentication.userId,
  authentication: state.authentication,
  formState: state.messageBoard.formState,
  allEvents: state.customerDashboard.allEvents,
  customerChatStarted: state.messageBoard.customerChatStarted,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getAllEventsByGroupId: (eventGroupId) =>
    dispatch(customerDashboardActions.getAllEventsByGroupId(eventGroupId)),
  getshutterbzByEventId: (eventId) =>
    dispatch(messageBoardActions.getshutterbByEventId(eventId)),
  setFormState: (data) => dispatch(messageBoardActions.setFormState(data)),
  getMessages: (eventId, sbUserId) =>
    dispatch(messageBoardActions.getMessages(eventId, sbUserId)),
  bulkUpdateMessageStatus: (eventId, sbUserId, userId, userType) =>
    dispatch(
      messageBoardActions.bulkUpdateMessageStatus(
        eventId,
        sbUserId,
        userId,
        userType
      )
    ),
  setCustomerChatStart: (data) =>
    dispatch(messageBoardActions.setCustomerChatStart(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MessageBoard));
